import { createSlice } from "@reduxjs/toolkit"

const initialState: { pageData: Array<any>, editMode: boolean, masterPageData: Array<any> } = {
    pageData: [],
    editMode: false,
    masterPageData: []
}

const pageDataSlice = createSlice({
    name: 'pageData',
    initialState,
    reducers: {
        setPageData: (state,action) => {
            state.pageData = action.payload
        },
        setEditMode: (state,action) => {
            state.editMode = action.payload
        },
        setMasterPageData: (state, action) => {
            state.masterPageData = action.payload
        }
    }
})

export const { setEditMode, setPageData, setMasterPageData } = pageDataSlice.actions
export default pageDataSlice.reducer